import { NocoDbList } from '../model/noco-db';
import {
	DataFetcher,
	DataFetcherMethod,
	DataFetcherProps,
} from './fetcher/DataFetcher';

export interface RepositoryGetProps extends Partial<DataFetcherProps> {
	id: number;
}
type RepositoryListProps = Partial<DataFetcherProps>;
export interface SearchProps<TSearchParams> extends Partial<DataFetcherProps> {
	search: TSearchParams;
}

export abstract class RepositoryNocoDbBase<T, TSearchParams = unknown> {
	protected abstract readonly API_ROUTE: string;
	protected abstract readonly META_ROUTE: string;
	protected constructor(protected _fetcher: DataFetcher) {}

	protected authHeaders = async () => {
		return {};
	};

	protected abstract composeSearchRoute(search: TSearchParams): string;

	async search({ search, ...fetchProps }: SearchProps<TSearchParams>) {
		const url = this.composeSearchRoute(search);
		return (
			await this._fetcher.execute<NocoDbList<T>>({
				method: DataFetcherMethod.Get,
				url,
				headers: await this.authHeaders(),
				...fetchProps,
			})
		).data;
	}

	async list({ ...fetchProps }: RepositoryListProps) {
		return (
			await this._fetcher.execute<NocoDbList<T>>({
				method: DataFetcherMethod.Get,
				url: this.API_ROUTE,
				headers: await this.authHeaders(),
				...fetchProps,
			})
		).data;
	}

	async get({ id, ...fetchProps }: RepositoryGetProps) {
		return (
			await this._fetcher.execute<T>({
				method: DataFetcherMethod.Get,
				url: `${this.API_ROUTE}/${id}`,
				headers: await this.authHeaders(),
				...fetchProps,
			})
		).data;
	}

	async getTableMetaInfo({ ...fetchProps }: RepositoryListProps) {
		return (
			await this._fetcher.execute<NocoDbList<T>>({
				method: DataFetcherMethod.Get,
				url: this.META_ROUTE,
				headers: await this.authHeaders(),
				...fetchProps,
			})
		).data;
	}
}
